import React from "react";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer">
        {/* Left Section */}
        <div className="footer-left-sec">
          <p>Privacy Policies</p>
          <p>Terms and Conditions</p>
        </div>

        {/* Middle Section */}
        <div className="footer-mid-sec">
          <div className="social-icon-container">
            <img src="/bark-insta-icon.svg" alt="social-icons" />
            <img src="/bark-you-icon.svg" alt="social-icons" />
            <img src="/bark-x-icon.svg" alt="social-icons" />
            <img src="/bark-git-icon.svg" alt="social-icons" />
            <img src="/bark-link-icon.svg" alt="social-icons" />
          </div>
        </div>

        {/* Mobilev Middle Section */}
        <div className="right-icon-container mob-center-icons">
          <img src="/bark-ft1-icon.svg" alt="social-icons" />
          <img src="/bark-ft2-icon.svg" alt="social-icons" />
        </div>

        {/* Right Section */}
        <div className="footer-right-sec">
          <div className="footer-right-container">
            <div className="right-icon-container">
              <img src="/bark-ft1-icon.svg" alt="social-icons" />
              <img src="/bark-ft2-icon.svg" alt="social-icons" />
            </div>
            <div className="right-link-container">
              <p>Contact Us</p>
              <p>Support</p>
            </div>
          </div>
        </div>
      </div>

      {/* Mob Bottom-Middle Section */}
      <div className="footer-mid-sec mob-bott-mid-sec">
        <div className="social-icon-container">
          <img src="/bark-insta-icon.svg" alt="social-icons" />
          <img src="/bark-you-icon.svg" alt="social-icons" />
          <img src="/bark-x-icon.svg" alt="social-icons" />
          <img src="/bark-git-icon.svg" alt="social-icons" />
          <img src="/bark-link-icon.svg" alt="social-icons" />
        </div>
      </div>
    </footer>
  );
};